import React from 'react';

function Privacypolicy() {
  return (
    <div className='section_divs px-8 md:px-0'>
      {
       <div className='container py-16 mx-auto'><p className="text-start"><strong >Privacy Policy for krishnamalireddy.github.io</strong></p>
       <p className="text-start"><strong >Effective Date: 1 Jan 2023</strong></p>
       <p className="text-start"><strong >1. Introduction</strong></p>
       <p className="text-start">Welcome to the website of Krishna Chaitanya Malireddy (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;). This Privacy Policy outlines how we collect, use, and protect your personal information when you visit <u><a href="https://krishnamalireddy.github.io/" target="_new" >https://krishnamalireddy.github.io/</a></u> (the &quot;Website&quot;). Your privacy is important to us, and we are committed to safeguarding your personal data.</p>
       <p className="text-start"><strong >2. Information We Collect</strong></p>
       <p className="text-start">We may collect the following types of information when you visit our Website:</p>
       <ul className="text-start">
           <li >
               <p ><strong >Log Data:</strong> We automatically collect information that your browser sends whenever you visit our Website. This may include your IP address, browser type, device information, and the pages you visit.</p>
           </li>
           <li >
               <p ><strong >Cookies:</strong> We may use cookies and similar tracking technologies to enhance your browsing experience. You can manage your cookie preferences through your browser settings.</p>
           </li>
       </ul>
       <p className="text-start"><strong >3. How We Use Your Information</strong></p>
       <p className="text-start">We may use the information we collect for the following purposes:</p>
       <ul className="text-start">
           <li >
               <p ><strong >Website Functionality:</strong> To provide and maintain the Website&apos;s functionality and optimize your experience.</p>
           </li>
           <li >
               <p ><strong >Analytics:</strong> To analyze trends, track user interactions, and improve our content and services.</p>
           </li>
           <li >
               <p ><strong >Communication:</strong> To respond to your inquiries and provide you with information or updates related to our Website.</p>
           </li>
       </ul>
       <p className="text-start"><strong >4. Third-Party Services</strong></p>
       <p className="text-start">Our Website may contain links to third-party websites or services that are not operated by us. We do not have control over and are not responsible for the privacy practices or content of these websites. Please review the privacy policies of these third-party websites.</p>
       <p className="text-start"><strong >5. Security</strong></p>
       <p className="text-start">We take reasonable precautions to protect your personal information. However, no data transmission or storage can be guaranteed as completely secure. We cannot ensure the security of information you transmit to us.</p>
       <p className="text-start"><strong >6. Your Choices</strong></p>
       <p className="text-start">You have the right to:</p>
       <ul className="text-start">
           <li >Access and update your personal information.</li>
           <li >Opt-out of receiving communication from us.</li>
           <li >Delete your personal data, subject to any legal requirements.</li>
       </ul>
       <p className="text-start"><strong >7. Changes to this Privacy Policy</strong></p>
       <p className="text-start">We may update this Privacy Policy from time to time to reflect changes in our practices or for legal reasons. Any updates will be posted on this page with the revised effective date.</p>
       <p className="text-start"><strong >8. Contact Us</strong></p>
       <p className="text-start">If you have questions or concerns about our privacy practices or this Privacy Policy, please contact us at:</p>
       <p className="text-start"><a href="mailto:krishnamalireddy7@gmail.com">krishnamalireddy7@gmail.com</a></p>
        </div>
      }
    </div>
  );
}

export default Privacypolicy;
